module.exports = __webpack_public_path__ + "img/activity_icon.92a21e85.svg";